import React, { useState } from "react"
import { useStaticQuery, graphql } from "gatsby"
import { Link, Button } from "theme-ui"

// markup
const IndexPage = () => {
    const data = useStaticQuery(query)

    return (
        <>
            <p>
                To schedule an appointment or to find out more, contact us{" "}
                <Link to="/contact">here</Link>.
            </p>
        </>
    )
}

export default IndexPage

const query = graphql`
    query {
        company: strapiCompany(shortname: { eq: "TAH" }) {
            email
            address
            name
            tel
            whatsapp
        }
    }
`
